namespace RioERP.Web.Enums {
    export enum InvoiceType {
        SingleOrder = 1,
        MultipleOrder = 2
    }
    Serenity.Decorators.registerEnumType(InvoiceType, 'RioERP.Web.Enums.InvoiceType');
}
